import { module } from 'modujs';
import { DEFAULT_VUE_FORM, DEFAULT_VUE_DATA, isPostalCodeValid } from '../utils/form'

const { required, email, requiredIf, sameAs } = window.validators;

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$el = this.el
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        if(document.getElementById('animationPlaces')) {
            this.animationPlaces = JSON.parse(document.getElementById('animationPlaces').innerHTML)
        } else {
            this.animationPlaces = false
            console.error('Error : document element ID provided invalid')
        }

        if(document.getElementById('animationPubPlaces')) {
            this.animationPubPlaces = JSON.parse(document.getElementById('animationPubPlaces').innerHTML)
        } else {
            this.animationPubPlaces = false
            console.error('Error : document element ID provided invalid')
        }

        // Init vue
        this.initVue();
    }

    destroy() {
        super.destroy();
        this.app?.$destroy?.()
    }

    /////////////////////////
    // Vue Instance
    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Import vuelidate
        Vue.use(window.vuelidate.default);

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            ...DEFAULT_VUE_FORM,

            el: this.el,
            mixins: [ {
                data: DEFAULT_VUE_DATA(this.el),
            } ],
            data() {
                return {
                    formData: {
                        animationPlace: '',
                        pub: '',
                        animationSpecificAddress: '',
                        animationType: '',
                        personsNumber: '',
                        date:'',
                        hour:'',
                        language:'',
                        budget:'',
                        description: '',
                        name: '',
                        firstname: '',
                        email: '',
                        phone: '',
                        companyName: '',
                        decouverte:'',
                        terms: '',
                        newsletter:''
                    },
                    animationPlaces: moduleInstance.animationPlaces,
                    animationPubPlaces: moduleInstance.animationPubPlaces
                }
            },

            validations: {
                ...DEFAULT_VUE_FORM.validations.formData,

                formData: {
                    animationPlace: {
                        required
                    },
                    pub: {
                        required: requiredIf(function () {
                            return this.formData.animationPlace == 'dans-les-pubs-ludiques';
                        })
                    },
                    animationSpecificAddress: {
                        required: requiredIf(function () {
                            return this.formData.animationPlace == ('en-entreprise' || 'en-festival');
                        })
                    },
                    animationType: {
                        required: requiredIf(function () {
                            return this.formData.animationPlace != '';
                        })
                    },
                    personsNumber: {
                        required
                    },
                    date: {
                        required
                    },
                    hour: {
                        required
                    },
                    language: {
                        required
                    },
                    name: {
                        required
                    },
                    firstname: {
                        required
                    },
                    email: {
                        required,
                        email
                    },
                    phone: {
                        required
                    },
                    terms: {
                        sameAs: sameAs( () => true )
                    },
                    newsletter: {}
                }
            },

            created() {
                //Important to make scrollTo error working
                this.moduleInstance = moduleInstance
            },

            mounted() {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);

                const animationPlace = urlParams.get('animationPlace')

                if(animationPlace) {
                    this.formData.animationPlace = animationPlace
                }
            },

            computed: {
                ...DEFAULT_VUE_FORM.computed,

                currentAnimationTypes: function () {

                    if (this.formData.pub == '') {

                        const place = this.animationPlaces.find(place => place.id == this.formData.animationPlace)
                        return place.animationTypes ? place.animationTypes : [];

                    }
                },

                currentAnimationPubsTypes: function () {

                    if (this.formData.pub != '') {

                        const place = this.animationPubPlaces.find(place => place.name == this.formData.pub)
                        return place.animationPubTypes ? place.animationPubTypes : [];

                    }
                }
            },

            methods: {
                ...DEFAULT_VUE_FORM.methods,

                initialization: function () {

                    this.formData.pub = '',
                    this.formData.animationSpecificAddress = ''

                    console.log(this.formData)
                },

            }
        });
    }
}
